module.exports = __webpack_public_path__ + "static/img/fish12.9b484ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish12.png
// module id = Bd8W
// module chunks = 0